import React from 'react'
import { isMobile } from 'react-device-detect'
import Icon from './Icon'
import PendingConnectionDetailItem from './PendingConnectionDetailItem'
import PlainText from './PlainText'
import { TimelineLite } from 'gsap/TimelineLite'

class PendingConnectionDetails extends React.Component {
    hasContent () {
        return (this.props.items && this.props.items.length > 0) ||
            (this.props.type === 'expectedActivation' && this.props.items.length === 0)
    }

    handleClick () {
	    if (this.hasContent()) {
            if (this.details.classList.contains('closed')) {
                this.animateOpen()
            } else {
                this.animateClosed()
            }
        }
    }

    animateOpen () {
        const tl = new TimelineLite()

        tl.add(() => {
            this.details.classList.remove('closed')
            this.details.classList.add('open')
        })
        tl.to(this.svg, 0.2, { rotation: 0, transformOrigin: '50% 50%' }, 0)
        tl.set(this.details, { height: 'auto' }, 0)
        tl.from(this.details, 0.2, { height: 0 }, 0)
    }

    animateClosed () {
        const tl = new TimelineLite()

        tl.to(this.svg, 0.2, { rotation: 90, transformOrigin: '50% 50%' }, 0)
        tl.to(this.details, 0.2, { height: 0 }, 0)
        tl.add(() => {
            this.details.classList.remove('open')
            this.details.classList.add('closed')
        }, '-=0.1')
    }

    render () {
        const Details = () => {
            if (this.props.items && this.props.items.length > 0) {
                return this.props.items.map((item, key) => {
                    return <PendingConnectionDetailItem key={key} item={item} />
                })
            }
        }

        return (
            <div className='pending-connection-details px-4 py-3' id={this.props.type}>
                <div className='row' onClick={this.handleClick.bind(this)}>
                    <div className='col-md-4 col-10 d-flex align-items-center'>
                        <div>
                            <p className='my-0 sub-bold font-medium' dangerouslySetInnerHTML={{ __html: this.props.title }} />
                            {this.props.subTitle && !isMobile ? <small>{this.props.subTitle}</small> : ''}
                            {isMobile ? <small>{this.props.date}</small> : ''}
                        </div>
                    </div>
                    <div className='d-none d-md-flex col-md-2 offset-md-3 align-items-center'>
                        <p className='my-0 lime sub-bold font-medium'>{this.props.date ? this.props.date : 'To be advised'}</p>
                    </div>
                    <div className='col-md-3 col-2 d-flex align-items-center justify-content-center justify-content-md-end mt-3 mt-md-0'>
                        {this.hasContent()
                            ? <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    viewBox='0 0 34.02 34.02'
                                    className='toggle-icon'
                              >
                                <g id='Layer_2' data-name='Layer 2'>
                                    <g id='Layer_1-2' data-name='Layer 1'>
                                        <rect className='cls-1' y='12.76' width='34.02' height='8.5' rx='4.25' fill='#004346' />
                                        <rect
                                            className='cls-1' y='12.76' width='34.02' height='8.5' rx='4.25' fill='#004346' ref={el => this.svg = el}
                                            transform='translate(0 34.02) rotate(-90)'
                                        />
                                    </g>
                                </g>
                              </svg>
                            : ''}
                    </div>
                </div>
                <div className='details mt-3 closed' ref={el => this.details = el}>
                    {Details()}
                    {this.props.type === 'expectedActivation'
                        ? <React.Fragment>
                            <p>Your expected activation time depends on whether you have ordered a new mobile number or transferring your number from another carrier.</p>
                            <ul>
                                <li>New mobile number activation takes between 15 minutes and 4 hours.</li>
                                <li>Porting your number to Exetel sees 90% of ports complete within 3 hrs, however activation usually occurs completes within minutes.</li>
                                <li>
                                    Regardless of the time you order your service, porting your number to Exetel from other carriers or Telstra Retail and other Telstra Wholesale MVNO’s will take place during the following porting operation hours:
                                    <ul>
                                        <li>8am to 8pm AEST from Monday to Friday</li>
                                        <li>10am to 6pm AEST on Saturday</li>
                                    </ul>
                                </li>
                            </ul>
                          </React.Fragment>
                        : ''}
                </div>
            </div>
        )
    }
}

export default PendingConnectionDetails



// WEBPACK FOOTER //
// ./resources/js/components/PendingConnectionDetails.js